import _ from 'lodash';

export default {
	inheritAttrs: false,
	computed: {
		editionMode() {
			return this.viewData === 'edit';
		},
		viewData() {
			return this.$route.path.includes('edit')
				? 'edit'
				: this.$route.path.includes('copy')
				? 'copy'
				: 'add';
		},
		titleData() {
			return this.viewData === 'edit'
				? `Edit ${this.formType}`
				: this.viewData === 'copy'
				? `Copy ${this.formType}`
				: `New ${this.formType}`;
		},
		formType() {
			return this.$route.path.includes('laser') ? 'Laser' : 'Impact';
		},
		customerPath() {
			if (_.isEmpty(this.$route.params.customerId)) {
				return '';
			}

			return `/clients/${this.$route.params.customerId}`;
		}
	},
	methods: {
		showFormsHistory() {
			const changedEntityId = this.customerPath
				? this.$route.params.id
				: this.form.id;
			const path = `${this.customerPath ||
				''}/forms/${changedEntityId}/history`;
			this.$router.push({ path });
		}
	}
};
